var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevSocialMediaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dev-social-media-icon_svg__a",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dev-social-media-icon_svg__c",
    d: "M0 60h61V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dev-social-media-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dev-social-media-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25 11.193 0 25 0s25 11.193 25 25",
    fill: "#F8D7CC",
    mask: "url(#dev-social-media-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40 1H2a1 1 0 00-1 1v53a1 1 0 001 1h38a1 1 0 001-1V2a1 1 0 00-1-1",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 1H2a1 1 0 00-1 1v5h40V2a1 1 0 00-1-1",
    fill: "#E74A10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 57H2c-1.103 0-2-.897-2-2V2C0 .896.897 0 2 0h38c1.103 0 2 .896 2 2v7h-2V2H2v53h38V43h2v12c0 1.103-.897 2-2 2",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "dev-social-media-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dev-social-media-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#dev-social-media-icon_svg__d)",
    d: "M3 8h36V6H3zM4 5h2V3H4zM8 5h2V3H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12h34a3 3 0 013 3v22a3 3 0 01-3 3H35l-5 7-5-7h-5a3 3 0 01-3-3V15a3 3 0 013-3",
    fill: "#FEFEFE",
    mask: "url(#dev-social-media-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13c-1.103 0-2 .897-2 2v22c0 1.103.897 2 2 2h5c.323 0 .626.156.813.42L30 45.28l4.187-5.86A.997.997 0 0135 39h19c1.103 0 2-.897 2-2V15c0-1.103-.897-2-2-2H20zm10 35a.997.997 0 01-.813-.419l-4.702-6.58H20c-2.206 0-4-1.795-4-4V15c0-2.207 1.794-4 4-4h34c2.206 0 4 1.793 4 4v22c0 2.205-1.794 4-4 4H35.515l-4.702 6.58a.997.997 0 01-.813.42zM13 25H5V11h8v2H7v10h6zM5 30h8v-2H5zM5 34h8v-2H5zM5 38h8v-2H5zM5 42h8v-2H5zM5 46h14v-2H5z",
    fill: "#020303",
    mask: "url(#dev-social-media-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 24h-4v-1c0-.345.548-1.176.548-2.719 0-1.562-.387-2.268-1.205-2.813-.943-.629-2.38-.673-2.38.167v.676c0 1.876-1.307 3.078-2.476 4.022 0 0-1.819 1.667-2.487 1.667h-4v8h3c1.59 0 1.764 2 4 2h8c.78 0 1.844-.851 1.844-1.597l1.121-5.783C46.218 25.18 45.526 24 44 24",
    fill: "#E8E9EA",
    mask: "url(#dev-social-media-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 35h-8c-1.618 0-2.458-.814-3.07-1.41-.451-.437-.635-.59-.93-.59h-4V23h4.931c.313-.116 1.172-.755 1.881-1.404 1.112-.9 2.151-1.86 2.151-3.285v-.676c0-.6.306-1.109.838-1.394.914-.488 2.249-.17 3.097.395 1.171.78 1.65 1.836 1.65 3.645 0 1.218-.295 2.058-.471 2.56-.037.104-.07.19-.086.258L41 25c0 2.462-2.224 4.332-3.549 5.228a.999.999 0 11-1.119-1.657c.802-.543 2.668-1.976 2.668-3.57v-2c0-.282.088-.532.189-.822.152-.43.359-1.02.359-1.898 0-1.37-.315-1.685-.758-1.98a1.897 1.897 0 00-.827-.298v.308c0 2.5-1.853 3.996-2.848 4.8-1.348 1.24-2.413 1.89-3.115 1.89h-3v6h2c1.133 0 1.792.64 2.322 1.154.505.491.87.845 1.678.845h8c.272 0 .796-.416.846-.626l.016-.162 1.122-5.783c.082-.47.013-.892-.193-1.138-.163-.193-.429-.29-.791-.29h-1a1 1 0 110-2h1c.953 0 1.777.355 2.322 1.004.596.71.82 1.7.629 2.787l-1.111 5.726C45.755 33.845 44.219 35 43 35",
    fill: "#020303",
    mask: "url(#dev-social-media-icon_svg__d)"
  }))));
}
export default SvgDevSocialMediaIcon;